import { http } from '@/api/httpAxios'
import { AxiosPromise } from 'axios'
import createURLParams from '@/api/datasource/createURLParams'
import _ from 'lodash'

export default class UsersAPI {
  public static getUsersList(
    limit: number | null,
    offset: number,
    sort: [] | null,
    filter: { [k: string]: any } | null
  ): AxiosPromise {
    const filters = _.cloneDeep(filter)
    if (filters?.roles) {
      filters.roles = {
        filterType: 'array',
        array: filters.roles.filter
      }
    }

    if (filters?.userDepartments) {
      filters.position = filters.userDepartments
      delete filters.userDepartments
    }
    const params = createURLParams(limit, offset, sort, filters, false)
    return http.get('/rights/users', { params })
  }
  public static changeUserRoles(
    userId: number,
    roles: string[],
    departments: number[]
  ) {
    return http.put(`/rights/users/${userId}`, { roles, departments })
  }

  public static getProfile(userId: number) {
    return http.get(`/users/profile?userId=${userId}`)
  }

  public static updateProfile(data: any) {
    return http.put('/users/profile', data)
  }

  public static getWorkersByDepartment(depId: number) {
    return http.get(
      `/rights/users?limit=no&offset=no&filter=${JSON.stringify({
        workDepartmentId: depId
      })}`
    )
  }

  public static getWorkersByDepartments(depIds: number[]) {
    return http.get(
      `/rights/users?limit=no&offset=no&filter=${JSON.stringify({
        workDepartmentId: depIds
      })}`
    )
  }

  public static getStudentsByGroup(groupId: number) {
    return http.get(
      `/rights/users?limit=no&offset=no&filter=${JSON.stringify({ groupId })}`
    )
  }
}
